export enum RootCategory {
	Women = 1,
	Men = 2,
	Kids = 3,
	// TODO: replace with jewelry when ready
	Other = 189,
}
